import { render } from "./radar-chart.vue?vue&type=template&id=4fe2e439"
import script from "./radar-chart.vue?vue&type=script&lang=js"
export * from "./radar-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__